'use strict';

import { environment } from '@quartz-gov-legacy/environments/environment';

angular.module('recommendationModule')

.factory('grcRecommendationService', ['$http', function ($http) {
    var baseUrl = environment.apiUrl + '/Pilot/api/Recom';

    var service = {};

    function returnData(response) {
        return response.data;
    }

    // Get Lookup Attribute Values by Lookup Attribute Code
    service.getRecommendationLookups = function () {
        return $http
            .get(baseUrl + '/Recommendation/Lookups', { cache: true })
            .then(returnData);
    };

    // Lookup Attributes
    service.getLookupAttributes = function () {
        return $http
            .get(environment.apiUrl + '/Pilot/api/LookupAttribute/Value/For/Recommendation', { cache: true })
            .then(returnData);
    };

    // Create Recommendation
    service.createRecommendation = function (recommendation) {
        return $http
            .post(baseUrl + '/Recommendation', recommendation)
            .then(returnData);
    };

    // Get Recommendation
    service.getRecommendation = function (recommendationId, ignoreError) {
        return $http
            .get(baseUrl + '/Recommendation/' + recommendationId, {ignoreError: true})
            .then(returnData);
    };

    // Update Recommendation
    service.updateRecommendation = function (recommendation) {
        return $http
            .put(baseUrl + '/Recommendation/' + recommendation.RecommendationID, recommendation)
            .then(returnData);
    };

    // Delete Recommendation
    service.deleteRecommendation = function (recommendation) {
        return $http
            .delete(baseUrl + '/Recommendation/' + recommendation.RecommendationID)
            .then(returnData);
    };

    // Get Followup
    service.getFollowUpsByRecommendationID = function (recommendation) {
        var reqUrl = baseUrl + '/Recommendation/' + recommendation.RecommendationID + '/FollowUp'

        return $http
                .get(reqUrl)
                .then(returnData);
    };

    // Create Recommendation FollowUp
    service.createRecommendationFollowUp = function (recommendation, followUp) {
        var reqUrl = baseUrl + '/Recommendation/' + recommendation.RecommendationID + '/FollowUp';

        return $http.post(reqUrl, followUp)
                    .then(returnData);
    };

    // Get Follow up attachment
    service.getDownloadAttachmentUrl = function (recommendation, attachmentId) {
        return baseUrl + '/Recommendation/' + recommendation.RecommendationID
             + '/FollowUp/Attachment/' + attachmentId;
    };

    return service;
}]);
